'use strict';

(function () {
  'use strict';

  angular.module('vnext').controller('InspirationsUploadCtrl', InspirationsUploadCtrl);

  InspirationsUploadCtrl.$inject = ['$state', 'inspirationSvc'];

  /* @ngInject */
  function InspirationsUploadCtrl($state, inspirationSvc) {
    var vm = this;
    vm.newInspiration = {};
    vm.create = create;

    ////////////////

    function create(inspiration) {
      if (!inspiration.description) {
        inspiration.description = '';
      }
      inspirationSvc.create(inspiration).then(function () {
        $state.go('vnext.content.inspirations.list.manage');
      });
      vm.newInspiration = {};
    }
  }
})();